import * as Rx from 'rxjs';
import * as RxOp from 'rxjs/operators';

import {
  fetchCashAction,
  fetchCloseoutDetails,
  reprintCloseoutReports,
  cashActionReceipt,
} from '../../utils/api/client';
import { getPosApiUrl, getAccessToken } from '../../utils/state';
import { replaceAlerts } from '../../components/alert-bar/AlertBar.state';
import {
  GET_CASH_ACTION_DETAILS_REQUEST,
  GET_CLOSEOUT_DETAILS_REQUEST,
  SUBMIT_PRINT_RECEIPT,
  cashActionDetailsAlertBarAction,
  getCashActionDetailsSuccess,
  getCashActionDetailsError,
  postReceiptSuccess,
  getCloseoutDetailsSuccess,
  REPRINT_CLOSEOUT_REPORTS_REQUEST,
  reprintCloseoutReportsSuccess,
} from './CashActionDetails.state';
import { caughtError } from '../../utils/api/errorHandler';

const caughtCashActionDetailsError = (state) =>
  caughtError(
    cashActionDetailsAlertBarAction,
    'Cash Action Details Page Error:',
    state,
  );

const getCashActionParams = (state, payload) => ({
  url: getPosApiUrl(state),
  token: getAccessToken(state),
  id: payload,
});

export const getCashActionDetailsEpic = (action$, state$) =>
  action$.ofType(GET_CASH_ACTION_DETAILS_REQUEST).pipe(
    RxOp.flatMap((action) =>
      Rx.from(
        fetchCashAction(getCashActionParams(state$.value, action.payload)),
      ).pipe(
        RxOp.flatMap((response) =>
          Rx.of(getCashActionDetailsSuccess(response.data)),
        ),
        RxOp.catchError((err) =>
          caughtCashActionDetailsError(state$.value)(
            err,
            getCashActionDetailsError(err.message),
          ),
        ),
      ),
    ),
  );

const caughtCashActionReceiptError = (state) =>
  caughtError(cashActionDetailsAlertBarAction, 'Receipt Error:', state);

const printReceiptParams = (state) => ({
  url: getPosApiUrl(state),
  token: getAccessToken(state),
  type: 'print',
  id: state.cashActionDetails.data.id,
});

export const printReceiptEpic = (action$, state$) =>
  action$.ofType(SUBMIT_PRINT_RECEIPT).pipe(
    RxOp.flatMap(() =>
      Rx.from(cashActionReceipt(printReceiptParams(state$.value))).pipe(
        RxOp.flatMap((response) =>
          Rx.of(
            postReceiptSuccess(response?.data),
            cashActionDetailsAlertBarAction(
              replaceAlerts({
                heading: 'Receipt Printed',
                text: `Receipt for cashAction: ${state$.value.cashActionDetails.data.id} has been successfully printed.`,
                variant: 'success',
              }),
            ),
          ),
        ),
        RxOp.catchError((err) =>
          caughtCashActionReceiptError(state$.value)(err),
        ),
      ),
    ),
  );

const getCloseoutDetailsParams = (state, payload) => ({
  url: getPosApiUrl(state),
  token: getAccessToken(state),
  id: payload,
});

export const getCloseoutDetailsEpic = (action$, state$) =>
  action$.ofType(GET_CLOSEOUT_DETAILS_REQUEST).pipe(
    RxOp.flatMap((action) =>
      Rx.from(
        fetchCloseoutDetails(
          getCloseoutDetailsParams(state$.value, action.payload),
        ),
      ).pipe(
        RxOp.flatMap((response) =>
          Rx.of(getCloseoutDetailsSuccess(response.data)),
        ),
        RxOp.catchError((err) =>
          caughtCashActionDetailsError(state$.value)(
            err,
            getCashActionDetailsError(err.message),
          ),
        ),
      ),
    ),
  );

const reprintReportsDetailsParams = (state, payload) => ({
  url: getPosApiUrl(state),
  token: getAccessToken(state),
  id: payload,
});

export const reprintCloseoutDetailsEpic = (action$, state$) =>
  action$.ofType(REPRINT_CLOSEOUT_REPORTS_REQUEST).pipe(
    RxOp.flatMap((action) =>
      Rx.from(
        reprintCloseoutReports(
          reprintReportsDetailsParams(state$.value, action.payload),
        ),
      ).pipe(
        RxOp.flatMap((response) =>
          Rx.of(
            reprintCloseoutReportsSuccess(response.data),
            cashActionDetailsAlertBarAction(
              replaceAlerts({
                heading: 'Reports Generated',
                text: 'Report generated successfully',
                variant: 'success',
              }),
            ),
          ),
        ),
        RxOp.catchError((err) =>
          caughtCashActionReceiptError(state$.value)(err),
        ),
      ),
    ),
  );
